import {
  maxLength,
  helpers,
} from '@vuelidate/validators';
import unique from './unique';
import { fieldRules } from './validationFieldRules';

/**
 * Extend the applicant creator.
 *
 * @param {*} extend 
 * @returns 
 */
export const extendApplicantCreator = (extend = {}) => (presets = {}) => ({
  id: unique(),
  FirstName: '',
  LastName: '',
  Ssn: '',
  AddedNewApplicant: '',
  Address: '',
  PostalCode: '',
  City: '',
  usePrimaryApplicantAddress: false,
  Phone: '',
  PhoneCountryCode: '+358',
  ContactLanguage: 'fi',
  Email: '',
  emailAgain: '',
  MarketingAllowed: false,
  ...extend,
  ...presets,
});

/**
 * Validations for the application.
 */
export const validations = {
  applicant: {
    FirstName: fieldRules.FirstName,
    LastName: fieldRules.LastName,
    Ssn: fieldRules.Ssn,
    AddedNewApplicant: fieldRules.AddedNewApplicant,
    Address: fieldRules.Address,
    PostalCode: fieldRules.PostalCode,
    City: fieldRules.City,
    usePrimaryApplicantAddress: fieldRules.usePrimaryApplicantAddress,
    Phone: fieldRules.Phone,
    PhoneCountryCode: fieldRules.PhoneCountryCode,
    ContactLanguage: fieldRules.ContactLanguage,
    Email: fieldRules.Email,
    emailAgain: fieldRules.emailAgain,
    MarketingAllowed: fieldRules.MarketingAllowed,
  },
  form: {
    OtherResidents: {
      $each: helpers.forEach({
        FirstName: fieldRules.FirstName,
        LastName: fieldRules.LastName,
        Ssn: fieldRules.Ssn,
      }),
    },
    AdditionalWishes: {
      maxLength: maxLength(1000),
    },
  },
};
